const axios = require('axios')
export  async function sendMsgToTgChat(msg = 'nothing') {
     const TOKEN = process.env.REACT_APP_TELEGRAM
     const CHAT = process.env.REACT_APP_TELEGRAM_CHAT
    const URL = `https://api.telegram.org/bot${TOKEN}/sendMessage`
    return await axios.get(URL, {params:{
        chat_id: CHAT,
        text: msg
    }})
}

// sendMsgToTgChat('Василий, я в баню уехал').then(({ data }) => {
//     console.log(data)
// })

export function generateMsg (formData) {
 const formD = JSON.parse(formData)
 const msg = `
 ${formD.Email || ''} - ${formD.Phone || ''}
 ${formD.Items[0].Name || 'ошибка'}
 ${formD.Items[0].Price.slice(0,-2)} ₽
 `
 return msg
}

// form.receipt.value = JSON.stringify({
//     Email: email,
//     Phone: phone,
//     EmailCompany: "mail@mail.com",
//     Taxation: "usn_income_outcome",
//     Items: [
//       {
//         Name: `${description} ${carPlate} ${range} пробег ${mileage}`,
//         Price: amount + "00",
//         Quantity: 1.0,
//         Amount: amount + "00",
//         PaymentMethod: "full_prepayment",
//         PaymentObject: "service",
//         Tax: "none",
//         ShopCode: "TBD"
//       }
//     ]
